import { render, staticRenderFns } from "./SettingsDeviceAndActives.vue?vue&type=template&id=16f33d39&scoped=true"
import script from "./SettingsDeviceAndActives.vue?vue&type=script&lang=js"
export * from "./SettingsDeviceAndActives.vue?vue&type=script&lang=js"
import style0 from "./SettingsDeviceAndActives.vue?vue&type=style&index=0&id=16f33d39&prod&lang=scss&scoped=true"
import style1 from "./SettingsDeviceAndActives.vue?vue&type=style&index=1&id=16f33d39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f33d39",
  null
  
)

export default component.exports